import { Record } from "immutable";

export const Segment = Record({
  title: "",
  matchingScope: "",
  points: 0,
  createFromType: "",
  createFromId: 0,
});

export const serializeSegment = function (segment) {
  const { title, points, matchingScope, createFromType, createFromId } = segment.toJS();

  return {
    title,
    points,
    matching_scope: matchingScope,
    created_from_type: createFromType,
    created_from_id: createFromId,
  };
};
